<template>
  <div class="project-item">
    <h4>{{ item.name }}</h4>
    <div class="project-item__type">
      <div class="secondary_text">
        Тип проекта:
        <span class="secondary_text_slim">{{ item.type }}</span>
      </div>
    </div>
    <div class="project-item__profile secondary_text">
      Портфель:
      <span class="secondary_text_slim">{{ item.briefcases.join(', ') }}</span>
    </div>
    <div class="project-item__leader secondary_text">
      Руководитель проекта
      <project-person
        class="person_info"
        :avatar="getAvatarUrl(item.leaderAvatarUid)"
        :name="item.leaderName"
        :email="item.leaderEmail"
      />
    </div>
  </div>
</template>

<script setup>
  import ProjectPerson from '@/views/performer/components/ProjectPerson.vue';

  defineProps({
    item: {
      type: Object,
      required: true,
    },
  });

  const getAvatarUrl = (avatar) =>
    avatar ? `/api/v1/attachment/${avatar}` : null;
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors' as *;

  .project-item {
    background: $color-bg-primary-white;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    h4 {
      margin-bottom: 16px;
    }

    &__type {
      margin-bottom: 16px;
    }

    &__profile {
      margin-bottom: 30px;
    }

    .person_info {
      margin-top: 14px;
    }
  }

  .secondary_text {
    font-family: Nunito Sans, sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: $color-text-secondary-grey-profile;

    &_slim {
      font-weight: 400;
    }
  }
</style>
